// utils/promptFields.js — Anamoria SPA
// v1.0 — 2.2a: prompt attribution on memory create (July 29, 2026)
//
// Pure helper shared by the capture save path. Extracted so the save-through
// rules — which are easy to get subtly wrong — are unit-testable without
// mounting the page. Mirrors the RecordPage v5.9 contract exactly:
//   - promptText / promptTitle are sent whenever a prompt is present, NOT gated
//     on promptId (custom group prompts have a null promptId — prompts v1.3).
//   - promptId is sent only when present; the caller fires prompt/respond only
//     when promptId is set.
//   - groupPromptId is preserved when present (memories.group_prompt_id).
//
// Dismiss rule (2.2a decision, Sophie 2026-07-29): a prompt the person set aside
// is NOT recorded on the memory. dismissed === true ⇒ no attribution at all.

export function buildPromptFields(prompt, dismissed = false) {
  if (!prompt || dismissed) return {};
  const fields = {
    // denormalized wording, always sent when a prompt is present
    promptText: prompt.text || null,
    promptTitle: prompt.title || prompt.category || null,
  };
  if (prompt.promptId) fields.promptId = prompt.promptId;
  if (prompt.groupPromptId) fields.groupPromptId = prompt.groupPromptId;
  return fields;
}
